
import {httpservice} from '../services';
import {constants} from '../constant/constant';
import {SOFTWARE} from "../constant/actionTypes";

export default () => dispatch => {
    dispatch({
        payload: [],
        type: SOFTWARE.SUBMODULE_LIST.INITIATE
    });

    return httpservice()
        .get(`${constants.API.SOFTWARE_SUBMODULE_LIST}`)
        .then(response => {
            dispatch({
                payload: response.data.response,
                type: SOFTWARE.SUBMODULE_LIST.SUCCESS
            });
            return response.data.response;
        })
        .catch(function (error) {
            dispatch({
                payload: error,
                type: SOFTWARE.SUBMODULE_LIST.ERROR
            });
        });
};
